import React from 'react';
import { Section } from './ui/Section';
import { Accordion } from './ui/Accordion';
import { Button } from './ui/Button';
const modules = [{
  title: 'Módulo 1: Diagnóstico de tu "curva de energía" (en 5 minutos)',
  content: 'Entiende exactamente dónde y por qué pierdes energía para poder actuar con precisión quirúrgica.'
}, {
  title: 'Módulo 2: El enemigo real: picos, caídas y rescates',
  content: 'Descubre la fisiología detrás de tus antojos y por qué la fuerza de voluntad no tiene nada que ver.'
}, {
  title: 'Módulo 3: Sistema Energía en 3 Bloques (la estructura diaria)',
  content: 'El corazón del método: cómo organizar tu día alimentario para maximizar el rendimiento vespertino.'
}, {
  title: 'Módulo 4: Plato 40/30/30 (plantilla visual)',
  content: 'Aprende a montar platos equilibrados visualmente sin necesidad de básculas ni apps de conteo.'
}, {
  title: 'Módulo 5: Orden de bocado (cambio mínimo, impacto grande)',
  content: 'La técnica científica simple para reducir el impacto glucémico de tus comidas sin cambiar lo que comes.'
}, {
  title: 'Módulo 6: Carbo inteligente mediterráneo (sin demonios)',
  content: 'Cómo reintroducir los carbohidratos de forma estratégica para que te den energía en lugar de sueño.'
}, {
  title: 'Módulo 7: 10 plantillas de Comida Base "Energía Alta"',
  content: 'Opciones deliciosas, rápidas y mediterráneas para tus comidas principales.'
}, {
  title: 'Módulo 8: Micro-Ajustes 16:00–17:30 (lista práctica)',
  content: 'Snacks estratégicos diseñados específicamente para prevenir el bajón de media tarde.'
}, {
  title: 'Módulo 9: Cenas inteligentes (5 plantillas rápidas)',
  content: 'Cenas que te nutren y preparan tu cuerpo para un descanso reparador.'
}, {
  title: 'Módulo 10: Plan 14 días + tracker + correcciones en 48h',
  content: 'Tu hoja de ruta paso a paso para implementar todo el sistema sin agobios.'
}];
export function ModulesAccordion() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <Section className="bg-white" data-id="element-274">
      <div className="max-w-3xl mx-auto" data-id="element-275">
        <div className="text-center mb-8" data-id="element-276">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2c4a2c] mb-3" data-id="element-277">
            Qué hay dentro (módulos)
          </h2>
          <p className="text-lg text-[#5a5a5a]" data-id="element-278">
            Todo está organizado para que no te pierdas y puedas aplicar rápido.
          </p>
        </div>

        <Accordion items={modules} data-id="element-279" />

        <div className="mt-8 text-center" data-id="element-280">
          <Button size="lg" data-id="element-281">Empezar por el Módulo 1</Button>
          <button onClick={scrollToPricing} className="mt-3 block mx-auto text-sm text-white bg-[#c45d3a] hover:bg-[#a84a2a] px-6 py-3 rounded-lg cursor-pointer transition-all font-medium shadow-xl shadow-[#c45d3a]/40 hover:shadow-2xl hover:shadow-[#a84a2a]/50 active:scale-[0.98] hover:scale-[1.01]" data-id="element-282">
            Enfoque "hazlo hoy", no "estúdialo un mes" → $6.39
          </button>
        </div>
      </div>
    </Section>;
}